import { useState } from "react"
import { styled } from "@mui/material/styles"
import MuiDrawer from "@mui/material/Drawer"
import MuiAppBar from "@mui/material/AppBar"
import List from "@mui/material/List"
import Divider from "@mui/material/Divider"
import IconButton from "@mui/material/IconButton"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { useLocation } from "react-router-dom"
import MenuList from "./Features/menuList"
// import { headerIcons } from "../../cdnImages"
import styles from "./sideMenu.module.css"
import UserProfile from "./Features/UserProfile"
import { headerIcons } from "../../cdnImages"

const drawerWidth = 240

const openedMixin = theme => ({
    "--drawer-width": "246px",
    width: "var(--drawer-width)",
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.between("desktop_md", "desktop_lg")]: {
        "--drawer-width": "295.2px",
    },
    [theme.breakpoints.up("desktop_lg")]: {
        "--drawer-width": "369px",
    },
    overflowX: "hidden",
})

const closedMixin = theme => ({
    "--drawer-width": "66px",
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "var(--drawer-width)",
    [theme.breakpoints.between("desktop_md", "desktop_lg")]: {
        "--drawer-width": "91px",
    },
    [theme.breakpoints.up("desktop_lg")]: {
        "--drawer-width": "113px",
    },
})

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}))

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: prop => prop !== "open",
})(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({ open }) => open,
            style: {
                marginLeft: drawerWidth,
                width: `calc(100% - ${drawerWidth}px)`,
                transition: theme.transitions.create(["width", "margin"], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}))

// const Drawer = styled(MuiDrawer, { shouldForwardProp: !['open', 'isHover', 'isProfileMenuOpen'].includes(prop) })(({ theme, open, isHover , isMenuOpen }) => ({
//     flexShrink: 0,
//     whiteSpace: "nowrap",
//     boxSizing: "border-box",
//     position: "sticky",
//     ...(open && {
//         ...openedMixin(theme),
//         "& .MuiDrawer-paper": openedMixin(theme),
//     }),
//     ...(!open && {
//         ...closedMixin(theme),
//         "& .MuiDrawer-paper": {
//             ...closedMixin(theme),
//             "&:hover": openedMixin(theme),
//         },
//     }),
// }))

const Drawer = styled(MuiDrawer, {
    shouldForwardProp: prop => !["open", "isHover", "isProfileMenuOpen"].includes(prop),
})(({ theme, open, isHover, isProfileMenuOpen }) => {
    const shouldExpand = open || isHover || isProfileMenuOpen

    return {
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        position: "sticky",

        // Apply width to wrapper (needed for CSS var propagation)
        ...(shouldExpand ? openedMixin(theme) : closedMixin(theme)),

        "& .MuiDrawer-paper": {
            ...(shouldExpand ? openedMixin(theme) : closedMixin(theme)),

            // Hover expand when drawer is closed
            //   "&:hover": !shouldExpand ? openedMixin(theme) : {},
        },
    }
})

export default function MiniDrawer(props) {
    const [open, setOpen] = useState(false)
    const [isHover, setIsHover] = useState(false)
    const { navbarStructure, userInfo, userRoles, internalRoutesRbacMap } = props
    const [userProfileOpen, setUserProfileOpen] = useState(null)
    const location = useLocation()
    // const [module, subModule] = location.pathname.split("/").filter(Boolean);

    const resolveParentPath = pathname => {
        const matchedRoute = internalRoutesRbacMap.find(route => pathname.startsWith(route.path))

        return matchedRoute?.parent || pathname
    }

    const resolvedPath = resolveParentPath(location.pathname)

    const [module, subModule] = resolvedPath.split("/").filter(Boolean)

    return (
        <Drawer
            // PaperProps={{
            //     sx: {
            //         width: {
            //             desktop_sm: 100,
            //             desktop_md: 100,
            //             desktop_lg: 115,
            //         },
            //     },
            // }}
            className={styles.menu_drawer}
            variant="permanent"
            open={open}
            isHover={isHover}
            isMenuOpen={Boolean(userProfileOpen)}
            onMouseEnter={() => !open && setIsHover(true)}
            onMouseLeave={() => !open && setIsHover(false)}>
            <DrawerHeader
                sx={
                    open || isHover
                        ? {
                              justifyContent: "space-between",
                          }
                        : {}
                }>
                {open || isHover ? (
                    <img className={styles.menu_drawer__full_logo} src={headerIcons.brand_full_logo} alt="statiq" />
                ) : (
                    <img className={styles.menu_drawer__small_logo} src={headerIcons.brand_small_logo} alt="statiq" />
                )}
                <IconButton
                    sx={{
                        position: "fixed",
                        top: 16,
                        left: "calc(var(--drawer-width) - 12px)",
                        backgroundColor: "#fff",
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        padding: "2px",
                        zIndex: theme => theme.zIndex.drawer + 1,
                        transition: theme =>
                            theme.transitions.create("left", {
                                easing: theme.transitions.easing.sharp,
                                duration: theme.transitions.duration.standard,
                            }),
                    }}
                    onClick={() => {
                        setOpen(!open)
                    }}>
                    {!open || !isHover ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
            </DrawerHeader>

            <List className={styles.list_container}>
                {navbarStructure?.length > 0 ? (
                    navbarStructure?.map(text => {
                        return (
                            <>
                                <MenuList
                                    text={text}
                                    expandedModule={module}
                                    expandedSubModule={subModule}
                                    isSideMenuExpanded={open}
                                    isHover={isHover}
                                />
                            </>
                        )
                    })
                ) : (
                    <></>
                )}
            </List>
            <Divider />

            <UserProfile
                {...{ userInfo, userRoles }}
                anchorEl={userProfileOpen}
                setAnchorEl={setUserProfileOpen}
                isSideMenuExpanded={open}
                isHover={isHover}
            />
        </Drawer>
    )
}
